import MyBuilding from './MyBuilding';

export default MyBuilding;
